import { useMemo, useState } from 'react'
import { errorHandler } from '../../../../services/util/error.service'
import * as DeliveryHttp from '../../../../services/api/https/deliveries/delivery.http'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  INITIAL: 'INITIAL',
  LOADING_DATA: 'Carregando dados',
}

const INITIAL_STATE = {
  isLoading: true,
  loadingMessage: LOAD_MESSAGE.INITIAL,
  baterias: [],
  globalFilter: '',
  errorMessage: null,
}

export default function useBateriaCelularDrive() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    // Helper

    return {
      // Actions
      getBaterias(fleet_id) {
        DeliveryHttp.getBateriasByFleet(fleet_id)
          .then(baterias =>
            setState(prevState => ({
              ...prevState,
              baterias: baterias,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(error =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(error),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      resetState() {
        setState({ ...INITIAL_STATE })
      },

      onInit() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.LOADING_DATA }))
      },

      onInputFilter(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },
    }
  }, [])

  return { state, localDispatch }
}
